module.exports = __webpack_public_path__ + "static/media/108.19deb6cb.jpg";